import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody, TableHead } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const VLanTab = props => (
  <Grid container spacing={40}>
    {!props.hideDisclaimer && (
    <Grid item xs={12}>
      <Typography color="inherit" className={props.classes.disclaimer}>
        {props.translate("result_disclaimer")}
      </Typography>
    </Grid>
    )}
    <Grid item xs={6} className={props.classes.VLeftGrid}>
      <div className={props.classes.vSetupDiv}>
        <Typography className={props.classes.vSetupTitle} color="inherit">
          {props.translate("result_vlan_setup")}
        </Typography>
        <Typography className={props.classes.vSetupText} color="inherit">
          {props.subtestStatsResults.vlan.setup}
        </Typography>
      </div>
      <table>
        <tr>
          <th className={props.classes.vtabHeaderFirst}>
            {props.translate("result_vlan_tag")}
          </th>
          <th className={props.classes.vtabHeader}>{props.translate("id")}</th>
          <th className={props.classes.vtabHeader}>
            {props.translate("result_priority")}
          </th>
          <th className={props.classes.vtabHeader}>
            {props.translate("result_protocolid")}
          </th>
        </tr>
        <tr>
          <td className={props.classes.vtabDataFirst}>
            {props.translate("result_lvl1")}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag1id
              ? props.subtestStatsResults.vlan.vlantag1id
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag1priority
              ? props.subtestStatsResults.vlan.vlantag1priority
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag1protocol
              ? props.subtestStatsResults.vlan.vlantag1protocol
              : "--"}
          </td>
        </tr>
        <tr>
          <td className={props.classes.vtabDataFirst}>
            {props.translate("result_lvl2")}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag2id
              ? props.subtestStatsResults.vlan.vlantag2id
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag2priority
              ? props.subtestStatsResults.vlan.vlantag2priority
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag2protocol
              ? props.subtestStatsResults.vlan.vlantag2protocol
              : "--"}
          </td>
        </tr>
        <tr>
          <td className={props.classes.vtabDataFirst}>
            {props.translate("result_lvl3")}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag3id
              ? props.subtestStatsResults.vlan.vlantag3id
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag3priority
              ? props.subtestStatsResults.vlan.vlantag3priority
              : "--"}
          </td>
          <td className={props.classes.vtabData}>
            {props.subtestStatsResults.vlan.vlantag3protocol
              ? props.subtestStatsResults.vlan.vlantag3protocol
              : "--"}
          </td>
        </tr>
      </table>
    </Grid>
    <Grid item xs={6}>
      <Table className={props.classes.table}>
        <TableHead>
          <TableRow>
            <TableCell
              className={props.classes.tableheader_first}
              rowSpan={2}
            />
            <TableCell className={props.classes.tableheader} colSpan={3}>
              {props.translate("result_vlan_tags")}
            </TableCell>
            <TableCell className={props.classes.tableheader} rowSpan={2}>
              {props.translate("result_cur_util")}
            </TableCell>
            <TableCell className={props.classes.tableheader} rowSpan={2}>
              {props.translate("result_max_util")}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={props.classes.tableheader_sub_vlan}>
              {props.translate("result_lvl1id")}
            </TableCell>
            <TableCell className={props.classes.tableheader_sub_vlan}>
              {props.translate("result_lvl2id")}
            </TableCell>
            <TableCell className={props.classes.tableheader_sub_vlan}>
              {props.translate("result_lvl3id")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.subtestStatsResults &&
          props.subtestStatsResults.vlan.tags &&
          props.subtestStatsResults.vlan.tags.length
            ? props.subtestStatsResults.vlan.tags.map((item, k) => {
                return (
                  <TableRow key={k}>
                    <TableCell className={props.classes.tablecontent}>
                      {k + 1}
                    </TableCell>
                    <TableCell className={props.classes.tablecontent}>
                      {item.vlantag1id ? item.vlantag1id : "--"}
                    </TableCell>
                    <TableCell className={props.classes.tablecontent}>
                      {item.vlantag2id ? item.vlantag2id : "--"}
                    </TableCell>
                    <TableCell className={props.classes.tablecontent}>
                      {item.vlantag3id ? item.vlantag3id : "--"}
                    </TableCell>
                    <TableCell className={props.classes.tablecontent}>
                      {item.currentutilization &&
                        item.currentutilization.toFixed(3)}
                    </TableCell>
                    <TableCell className={props.classes.tablecontent}>
                      {item.maxutilization && item.maxutilization.toFixed(3)}
                    </TableCell>
                  </TableRow>
                );
              })
            : null}
        </TableBody>
      </Table>
    </Grid>
  </Grid>
);
export default withStyles(styles)(VLanTab);
